<template>
  <div class="savedCardDoc">
    <documentation-container :title="title">
      <template slot="content">
        <h2>Default Saved Card</h2>
        <div class="content-doc">
          <saved-card v-for="(saved, index) in saveds" :key="index" :saved="saved" :title="saved.title" :subtitle="saved.subtitle" :color="saved.color" :item="saved.item" />
        </div>
        <h2>Long Saved Card</h2>
        <div class="content-doc2">
          <saved-card v-for="(saved, index) in saveds2" :key="index" type="long" :saved="saved" :title="saved.title" :subtitle="saved.subtitle" :color="saved.color" :item="saved.item" />
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import SavedCard from '@/components/Card/SavedCard'
import DocumentationContainer from '@/components/DocumentationContainer'
import moment from 'moment'

export default {
  name: 'adx-saved-card-doc',
  components: {
    'saved-card': SavedCard,
    'documentation-container': DocumentationContainer
  },
  data() {
    return {
      title: 'Saved Card',
      saveds: [
        {
          title: 'Coca Cola',
          subtitle: '#Rayakannamamu',
          color: '#ff3b30',
          item: '140'
        },
        {
          title: 'Pocary Sweet',
          subtitle: '#Sweatgeneration',
          color: '#007aff',
          item: '250'
        },
        {
          title: 'Pantene Strong Is Beautiful',
          subtitle: '',
          color: '#ff9500',
          item: '250'
        },
        {
          title: 'Yellow Campaign Indonesia',
          subtitle: '',
          color: '#ffcc00',
          item: '250'
        },
        {
          title: 'Green Campaign Indonesia',
          subtitle: '',
          color: '#4cd964',
          item: '140'
        },
        {
          title: 'Teal Campaign Indonesia',
          subtitle: '',
          color: '#5ac8fa',
          item: '140'
        },
        {
          title: 'Purple Campaign Indonesia',
          subtitle: '',
          color: '#5856d6',
          item: '140'
        },
        {
          title: 'Pink Campaign Indonesia',
          subtitle: '',
          color: '#ff2d55',
          item: '140'
        }
      ],
      saveds2: [
        {
          title: 'Coca Cola',
          subtitle: '#Rayakannamamu',
          color: '#ff3b30',
          item: '140',
          created: moment().format('DD MMM YYYY')
        },
        {
          title: 'Pocary Sweet',
          subtitle: '#Sweatgeneration',
          color: '#007aff',
          item: '250',
          created: moment().format('DD MMM YYYY')
        },
        {
          title: 'Pantene Strong Is Beautiful',
          subtitle: '',
          color: '#ff9500',
          item: '250',
          created: moment().format('DD MMM YYYY')
        },
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>